<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5 class="text-center">Hallo
                    <br>
                    Bambang Abdul
                </h5>
            </template>
            
            <p class="text-center">Poin Anda</p>
            <h1 class="text-primary text-center">400</h1>
            <b-row align-h="center" class="text-center">
                <b-col cols="6">
                    <b-row no-gutters>
                        <b-col cols="2" class="border">1</b-col>
                        <b-col cols="2" class="border">2</b-col>
                        <b-col cols="2" class="border">3</b-col>
                        <b-col cols="2" class="border">4</b-col>
                        <b-col cols="2" class="border">5</b-col>
                        <b-col cols="2" class="border">6</b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col cols="2" class="border">7</b-col>
                        <b-col cols="2" class="border">8</b-col>
                        <b-col cols="2" class="border">9</b-col>
                        <b-col cols="2" class="border">10</b-col>
                        <b-col cols="2" class="border">11</b-col>
                        <b-col cols="2" class="border">12</b-col>
                    </b-row>
                </b-col>
            </b-row>
            <p class="pt-2 text-center">Bulan Berturut-turut</p>
            <b-row align-h="center" class="text-center">
                <b-col cols="12">
                    <img class="" src="../../../public/img/promoEmas.jpeg" width="100%" alt="">
                    <!-- <b-row>
                        <b-col cols="6" class="border p-3">
                            Bonus 6 Bulan
                            <img class="pt-3" src="../../../../../Downloads/a224cf478550d1e1b01c76f3d35bb43a.jpg" width="100%" alt="">
                        </b-col>
                        <b-col cols="6" class="border p-3">
                            Bonus 12 Bulan
                            <img class="pt-3" src="../../../../../Downloads/ANTAM10-432x432.jpg" width="100%" alt="">
                        </b-col>
                    </b-row> -->
                </b-col>
            </b-row>

            <b-tabs class="tab-wrapper pt-3" content-class="tab-content-wrapper"  @input="isEmas">
                <b-tab title="History">
                    <h5 class="pt-3 text-primary">Maret 2023</h5>
                    <b-row>
                        <b-col>
                            <h6>Gadai NF 943231293429 <br>
                                <small>21 Maret 2023</small>
                            </h6>
                        </b-col>
                        <b-col>
                            <h5>+ 45 Point</h5>
                        </b-col>
                    </b-row>
                    
                    <b-row>
                        <b-col>
                            <h6>PP NF 943231293429 <br>
                                <small>20 Maret 2023</small>
                            </h6>
                        </b-col>
                        <b-col>
                            <h5>+ 12 Point</h5>
                        </b-col>
                    </b-row>
                
                    <h5 class="pt-3 text-primary">Februari 2023</h5>
                    <b-row>
                        <b-col>
                            <h6>Gadai NF 943231293429 <br>
                                <small>21 Februari 2023</small>
                            </h6>
                        </b-col>
                        <b-col>
                            <h5>+ 45 Point</h5>
                        </b-col>
                    </b-row>
                    
                    <b-row>
                        <b-col>
                            <h6>PP NF 943231293429 <br>
                                <small>20 Februari 2023</small>
                            </h6>
                        </b-col>
                        <b-col>
                            <h5>+ 12 Point</h5>
                        </b-col>
                    </b-row>
                    
                    <h5 class="pt-3 text-primary">Januari 2023</h5>
                    <b-row>
                        <b-col>
                            <h6>Gadai NF 943231293429 <br>
                                <small>21 Januari 2023</small>
                            </h6>
                        </b-col>
                        <b-col>
                            <h5>+ 45 Point</h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h6>PP NF 943231293429 <br>
                                <small>20 Januari 2023</small>
                            </h6>
                        </b-col>
                        <b-col>
                            <h5>+ 15 Point</h5>
                        </b-col>
                    </b-row>
                    
                </b-tab>
                <b-tab title="S & K">
                    Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum consequat non elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur mollit voluptate est in duis laboris ad sit ipsum anim Lorem.
                    Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla tempor. Laborum consequat non elit enim exercitation cillum aliqua consequat id aliqua. Esse ex consectetur mollit voluptate est in duis laboris ad sit ipsum anim Lorem.
                </b-tab>
            </b-tabs>            
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'promo-emas',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            jenisOption: [],

            isOpen: false,
            dropdownItems: ["Item 1", "Item 2", "Item 3"]
        }
    }, 

    methods: {
      
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
           
            let getJenisBarang = this.$axios.get("barang-jenis/").then(response => {
                this.jenisOption = response.data
            })

            Promise.all([getJenisBarang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

    },

    created(){
        this.init()
    }
}
</script>
